import { parse } from 'query-string';
import Moment from 'moment';
import { LOCATION_CHANGE } from '../actions';
import { SET_FETCH_DATES } from '../actions/jobs';

const initialState = {
  timestamp: Moment().startOf('day').subtract(7, 'days').unix(),
  runCount: 60,
  lowerLatestFetch: Moment().startOf('day').unix(),
  upperLatestFetch: Moment().startOf('day').add(1, 'days').unix()
};

const metricsByDateInfo = (state = initialState, action) => {
  switch (action.type) {
    case SET_FETCH_DATES:
      return {
        ...state,
        lowerLatestFetch : action.lower,
        upperLatestFetch: action.upper
      };
    case LOCATION_CHANGE:
      if (!action.payload ||
        !action.payload.search ||
        !action.payload.pathname ||
        (!action.payload.pathname.includes('performance')) &&
        (!action.payload.pathname.includes('-metrics')))
      {
        // moved away from a metric page, reset the date info
        return initialState;
      }

      // These are for the main selector:
      // ts: moment timestamp from datepicker
      // c: run count
      // The names need to be short because they're part of the URL query.
      const { ts, c } = parse(action.payload.search);

      const parseMetricsInfo = (
        timestamp,
        runCount,
        metricInfo,
      ) => {
        const parsedRun = parseInt(runCount);
        const parsedTime = parseInt(timestamp);

        return {
          timestamp: (parsedTime < 0) || isNaN(parsedTime) ?
            metricInfo.timestamp :
            Moment(timestamp, 'X').unix(),
          runCount: (parsedRun < 0) || isNaN(parsedRun) ?
            metricInfo.runCount :
            parsedRun
        };
      };

      const parsedInfo =
        parseMetricsInfo(ts, c, state);
      return {
        ...state,
        timestamp: parsedInfo.timestamp,
        runCount: parsedInfo.runCount
      };

    default:
      return state;
  }
};

export default metricsByDateInfo;

export const getMetricsByDateInfo = state => state.metricsByDateInfo;
export const getMetricsByDateTimestamp = state =>
  getMetricsByDateInfo(state).timestamp;
export const getMetricsByDateRunCount = state =>
  getMetricsByDateInfo(state).runCount;
export const getMetricsByDateLowerLatestFetch = state =>
  getMetricsByDateInfo(state).lowerLatestFetch;
export const getMetricsByDateUpperLatestFetch = state =>
  getMetricsByDateInfo(state).upperLatestFetch;


// WEBPACK FOOTER //
// src/reducers/metricsByDateInfo.js